import { Text, theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';

import type { Card } from './HowItWorksSlider';

type HowItWorksCardProps = {
  card: Card;
  index: number;
};

const CardContainer = styled.div`
  height: 380px;
  width: 100%;
  display: flex;
  flex-direction: column;

  gap: ${theme.spacing['5x']};
  background: ${theme.colors.neutral[200]};
  border-radius: ${theme.radius.xs};
  padding: ${theme.spacing['8x']} ${theme.spacing['5x']};
  ${legacyTheme.breakpoints.up('sm')} {
    height: 100%;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 175px;
  min-height: 175px;
  position: relative;
  display: flex;
  grid-area: hero;
  overflow: hidden;
  border-radius: ${theme.radius.xs};
`;

const SliderImage = styled(Image)`
  height: 100%;
  object-fit: cover;
  top: 0;
`;

const TitleTextContainer = styled.div`
  height: 48px;
  width: 63%;
  ${legacyTheme.breakpoints.up('sm')} {
    width: 100%;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  gap: ${theme.spacing['2x']};
`;

export const HowItWorksCard = ({ card, index }: HowItWorksCardProps) => {
  const { imgSrc, imgAlt, title, description } = card;
  return (
    <CardContainer>
      <TitleWrapper>
        <Text color="neutral.900" variant="bodyLg">
          {index}/
        </Text>
        <TitleTextContainer>
          <Text as="h3" color="neutral.900" variant="bodyLg">
            {title}
          </Text>
        </TitleTextContainer>
      </TitleWrapper>
      <ImageContainer>
        <SliderImage alt={imgAlt} fill src={imgSrc.src} />
      </ImageContainer>
      <Text color="neutral.900" variant="bodySm">
        {description}
      </Text>
    </CardContainer>
  );
};
